import { gql } from "@apollo/client";

const GET_GL_CODE = gql`
  query GetGLCode {
    glCodes {
      count
      items {
        glCodeId
        glCode
        glCodeDescription
        displayName
      }
    }
  }
`;

export default GET_GL_CODE;
